import cn from 'classnames'
import React, { ComponentProps } from 'react'

type CheckmarkCircleIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CheckmarkCircleIcon(props: CheckmarkCircleIconProps) {
  const { className = '', ...rest } = props

  return (
    <svg
      className={cn('CheckmarkCircleIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.748 4.83594V4.83691C16.8769 4.96819 20.167 8.35816 20.167 12.5C20.167 16.7342 16.7342 20.167 12.5 20.167C8.26582 20.167 4.83301 16.7342 4.83301 12.5C4.83301 8.26647 8.26476 4.83406 12.498 4.83301L12.748 4.83594ZM17.21 9.18164C16.758 8.78991 16.0735 8.83828 15.6816 9.29004L11.2695 14.3789L9.29199 12.2607L9.27441 12.2432L9.19336 12.168L9.18359 12.1602L9.1748 12.1523L9.09473 12.0947C8.68656 11.8262 8.13375 11.8599 7.76074 12.208C7.32338 12.6162 7.29978 13.3019 7.70801 13.7393L10.5078 16.7393L10.5166 16.748L10.5254 16.7559L10.6055 16.8301L10.6143 16.8389L10.623 16.8467C11.0693 17.2043 11.7325 17.156 12.1191 16.71L17.3184 10.71L17.3271 10.7002L17.334 10.6904L17.4004 10.6016L17.4082 10.5918L17.4141 10.5811C17.6978 10.1355 17.6209 9.5381 17.21 9.18164Z"
        fill="#23B998"
        stroke="#23B998"
        strokeWidth="0.666667"
      />
    </svg>
  )
}
